import { useState } from "react"
import { Dialog, DialogTitle, DialogContent, Alert, Stack, TextField, IconButton, MenuItem } from "@mui/material"
import { LoadingButton } from "@mui/lab"
import EventsSelect from "./EventsSelect"
import moment from "moment"
import AdminSelect from "../../Inputs/AdminSelect"
import { Close } from "@mui/icons-material"
import API from "../../../services/API"
import { useEffect } from "react"

export default function Form({open, onClose, onSuccess, data}){

    const [item, setItem] = useState({})

    const [status, setStatus] = useState('ready')

    const statusIs = str => str === status

    useEffect(() => {

        let item = {
            note: '',
            date: moment().add(1,'days').format('YYYY-MM-DD'),
            time: '09:00'
        }

        Object.assign(item, data)

        setItem(item)

        setStatus('ready')
    
        return () => setItem({})

    }, [data])

    const typeIs = str => str === item?.type?.id 

    const typeIn = arr => arr.includes(item?.type?.id)

    const handleSubmit = e => {
        e.preventDefault();

        setStatus('submit')

        API.post(`/crm/activities`, item)
            .then(r => {
                console.log(r.data)
                onSuccess(r.data)
            })
            .catch(e => {
                console.log('POST activity : ', e.response?.status, e?.response?.item)
                setStatus('error')
            })
    }

    const handleChange = (key, val) => {
        let copy = {...item};
        copy[key] = val;

        if(typeIs('reminder')){
            copy.expiredAt = moment(copy.date + 'T' + copy.time + ':00').format('YYYY-MM-DD HH:mm:ss');
        }

        if(typeIs('email')){
            copy.note = copy.email ? copy.email.title : '';
        }

        return setItem(copy);
    }

    return <Dialog open={open} onClose={onClose}>

        <Stack direction='row' justifyContent='space-between' alignItems='center'>
            
            <DialogTitle>{titles[item?.type?.id]}</DialogTitle>

            <IconButton onClick={onClose} size='small' sx={{m: 1}}>
                <Close />
            </IconButton>

        </Stack>

        <DialogContent>

            <form onSubmit={handleSubmit}>

                <Stack spacing={3} width={350}>

                    {statusIs('error') &&
                        <Alert severity='error'>Une erreur s'est produite.</Alert>
                    }

                    {typeIn(['note','deal']) && 
                    
                        <EventsSelect 
                            value={item.events}
                            onChange={v => handleChange('events', v)}
                        />
                    }

                    {typeIs('reminder') && <>
                    
                        <TextField
                            type="date"
                            onChange={e => handleChange('date', e.target.value)}
                            defaultValue={item.date}
                            required
                            size='small'
                        />

                        <TextField
                            type="time"
                            onChange={e => handleChange('time', e.target.value)}
                            inputProps={{min: '00:00', max: '23:59'}}
                            defaultValue={item.time}
                            required
                            size='small'
                        />

                    </>}

                    {typeIn(['note','reminder','deal']) &&

                        <TextField
                            label="Commentaire"
                            required={!typeIs('deal')}
                            autoFocus
                            value={item.note}
                            onChange={e => handleChange('note', e.target.value)}
                            inputProps={{maxLength: 500}}
                            multiline
                        />
                    }

                    {typeIs('email') &&

                        <TextField
                            label='Email à envoyer'
                            value={item.email?.id || ''}
                            onChange={e => handleChange('email', emails.find(m => m.id === e.target.value))}
                            required
                            select
                            size='small'
                        >
                            <MenuItem value=''>Choisir un email</MenuItem>    
                            {emails.map(e => 
                                <MenuItem value={e.id} key={e.id}>{e.title}</MenuItem>    
                            )}
                        </TextField>
                    }


                    <AdminSelect
                        label="Taguer quelqu'un"
                        value={item.taggedUser}
                        onChange={user => handleChange('taggedUser', user)}
                    />

                        
                    <LoadingButton
                        variant='contained'
                        type='submit'
                        loading={statusIs('submit')}
                    >
                        Valider
                    </LoadingButton>

                </Stack>

            </form>

        </DialogContent>

    </Dialog>
}

const titles = {
    reminder: 'Rappel',
    deal: 'Affaire',
    note: 'Note',
    email: 'Envoyer un email'
}

const emails = [
    {id: 'welcome', title: 'Bienvenue sur LearnyLib'},
    {id: 'forgot_password', title: 'Réinitialisez votre mot de passe'},
];